import React from "react";

const EmptyState = ({ user, stats, variant = "desktop" }) => {
  if (variant === "mobile") {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center px-4">
        <div className="bg-white rounded-lg p-6 shadow-sm max-w-sm w-full">
          <h2 className="text-xl font-bold mb-4">Hi {user?.firstName}! 👋</h2>
          <div className="grid grid-cols-3 gap-4 text-center mb-6">
            <div>
              <div className="text-lg font-bold text-blue-600">
                {stats?.totalCorrect || 0}-{stats?.totalIncorrect || 0}
              </div>
              <div className="text-xs text-gray-500">Season</div>
            </div>
            <div>
              <div className="text-lg font-bold text-green-600">
                {stats?.picksRemaining || 0}
              </div>
              <div className="text-xs text-gray-500">Remaining</div>
            </div>
            <div>
              <div className="text-lg font-bold text-orange-600">
                {stats?.winPercentage ? `${stats.winPercentage}%` : "0.0%"}
              </div>
              <div className="text-xs text-gray-500">Win Rate</div>
            </div>
          </div>
          <div className="text-gray-500">
            <div className="text-6xl mb-4">🏈</div>
            <p className="text-lg font-semibold">No games in next 48 hours</p>
            <p className="text-sm mt-2">Check back later for upcoming games</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <p className="text-gray-500 text-center">No games in the next 48 hours</p>
  );
};

export default EmptyState;
